export const MS_PER_MINUTE = 60000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * MINUTES_PER_HOUR;
export const SECONDS_IN_FIVE_MINUTES = SECONDS_PER_MINUTE * 5;
export const HOURS_PER_DAY = 24;
export const SECONDS_PER_DAY = SECONDS_PER_HOUR * HOURS_PER_DAY;
export const DAYS_PER_NONE_LEAPYEAR = 365;
export const SECONDS_PER_365_DAYS = SECONDS_PER_DAY * DAYS_PER_NONE_LEAPYEAR;
